import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import utils from 'helpers/utils';

const UserIdFilter = <AutoCompleteFilter
    label='filters.components.userId.label'
    formatSuggestion={ (user) => {
        return `${ utils.fullName(user.first_name, user.last_name) } (${ user.id })`;
    } }
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        size: '12',
        sort_by: 'last_name',
        sort_direction: 'asc',
    } }
    reference='users'
    optionValue='id'
    searchBy='last_name'
    source='user_id'
/>;

export default UserIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/UserIdFilter.js